/**
 * Returns the API base URL.
 * Uses relative URLs (empty string) so API calls go to the same origin,
 * which works for both custom domains and preview deployments.
 * Falls back to REACT_APP_BACKEND_URL only when explicitly set and different from origin.
 */
const envUrl = process.env.REACT_APP_BACKEND_URL || '';

function getApiUrl() {
  if (typeof window === 'undefined') return envUrl;
  // If env URL matches current origin, use relative (avoids cross-origin issues)
  if (!envUrl || envUrl === window.location.origin) return '';
  // If env URL is a different emergentagent preview or same base domain, use relative
  // This handles custom domains like auth.mojomoney.africa where the backend is same-origin
  return '';
}

export const API_URL = getApiUrl();
